// @core/api/endpoints/secret/generate_data_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GenerateDataKeyRequest,
  GenerateDataKeyResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Generate data key
 * Generates a new high-entropy data encryption key, wrapped (encrypted) by the named Transit key. Optionally returns the plaintext key for immediate use (envelope encryption pattern).
 */
export async function GenerateDataKey(
  engine_id: string,
  key_name: string,
  data: GenerateDataKeyRequest,
  options?: RequestOptions
): Promise<GenerateDataKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/datakey/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.post<GenerateDataKeyResponse>(requestPath, data, requestOptions);
}
